import { Text } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect } from "react";
import { getPerfectDate } from "../../../../helpers/utils";
import { RelatedTableData } from "../../../../types/formDataTypes";
import { EquipmentById, Equipment } from "../../../../types/types";
import _ from "lodash";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../../../ui/DataTable/DataTable";
import { useAppStore } from "../../../../stores/RootStore";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { TbX } from "react-icons/tb";

type Props = {
  currentEquipment: Equipment | undefined;
};

const RelatedTab = ({ currentEquipment }: Props) => {
  const equipments = useAppStore().equipments
  const childrensIds = currentEquipment?.attributes.children_ids;
  const childData = childrensIds?.map((id) => equipments?.find((eq) => id == eq.id));

  let nodes = childData?.map((data) => {
    return {
      id: data?.id,
      name: data?.attributes.name,
      parent_changed_at: data?.attributes.parent_changed_at,
      inventory_number: data?.attributes.inventory_number,
      equipment_model_name: data?.attributes.equipment_model_name,
      producer_name: data?.attributes.producer_name,
      factory_number: data?.attributes.factory_number,
      division_name: data?.attributes.division_name,
      division_changed_at: data?.attributes.division_changed_at,
      status: data?.attributes.status,
      status_changed_at: data?.attributes.status_changed_at,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };


  return (
    <div className="overflow-hidden max-w-[1008px]">
        <div className="flex flex-col px-4 gap-1">
          {nodes.map(item => (
            <div key={item.id} className="pt-1 pb-2">
              <div className="flex justify-between text-xs">
                <span>{t('related_at')}</span>
                <span>{item.parent_changed_at}</span>
              </div>
              <div className="text-base">{item.name}</div>
              <div className="text-base">{item.producer_name + " " + item.equipment_model_name}</div>
              <div className="text-base">{item.inventory_number + " " + item.factory_number}</div>
            </div>
          ))}
        </div>
    </div>
  );
};

export default RelatedTab;
